import { MainRoutes } from '@/routes/RoutePaths';

export interface IJmsManagementRoutes {
  Inmates: string;
  Bookings: string;
  SearchPerson: string;
  CreateIdentity: string;
  CreateBooking: string;
  EditIdentity: (bookingId?: string) => string;
  EditInmateContextIdentity: (inmateId?: string) => string;
  ViewInmateContextIdentity: (inmateId?: string) => string;
  EditInmateContextNotes: (inmateId?: string) => string;
  ViewInmateContextNotes: (inmateId?: string) => string;
  EditInmateContextHousing: (inmateId?: string) => string;
  ViewInmateContextHousing: (inmateId?: string) => string;
  ViewInmateContextBookingHistory: (inmateId?: string) => string;
  ViewIdentity: (bookingId?: string) => string;
  EditBooking: (bookingId?: string) => string;
  ViewBooking: (bookingId?: string) => string;
  EditFingerprints: (bookingId?: string) => string;
  EditProperties: (bookingId?: string) => string;
  EditHousing: (bookingId?: string) => string;
}

export const JmsManagementRoutes: IJmsManagementRoutes = {
  Inmates: MainRoutes.JmsManagement,
  Bookings: `${MainRoutes.JmsManagement}/bookings`,
  SearchPerson: `${MainRoutes.JmsManagement}/search-person`,
  CreateIdentity: `${MainRoutes.JmsManagement}/create/identity`,
  CreateBooking: `${MainRoutes.JmsManagement}/create/booking`,
  EditIdentity: (bookingId) =>
    `${MainRoutes.JmsManagement}/booking/${bookingId}/identity`,
  EditInmateContextIdentity: (inmateId) =>
    `${MainRoutes.JmsManagement}/inmate/${inmateId}/identity`,
  ViewInmateContextIdentity: (inmateId) =>
    `${MainRoutes.JmsManagement}/inmate/${inmateId}/identity?mode=view`,
  EditInmateContextNotes: (inmateId) =>
    `${MainRoutes.JmsManagement}/inmate/${inmateId}/notes`,
  ViewInmateContextNotes: (inmateId) =>
    `${MainRoutes.JmsManagement}/inmate/${inmateId}/notes?mode=view`,
  EditInmateContextHousing: (inmateId) =>
    `${MainRoutes.JmsManagement}/inmate/${inmateId}/housing`,
  ViewInmateContextHousing: (inmateId) =>
    `${MainRoutes.JmsManagement}/inmate/${inmateId}/housing?mode=view`,
  ViewInmateContextBookingHistory: (inmateId) =>
    `${MainRoutes.JmsManagement}/inmate/${inmateId}/booking-history`,
  ViewIdentity: (bookingId) =>
    `${MainRoutes.JmsManagement}/booking/${bookingId}/identity?mode=view`,
  EditBooking: (bookingId) =>
    `${MainRoutes.JmsManagement}/booking/${bookingId}/booking`,
  ViewBooking: (bookingId) =>
    `${MainRoutes.JmsManagement}/booking/${bookingId}/booking?mode=view`,
  EditFingerprints: (bookingId) =>
    `${MainRoutes.JmsManagement}/booking/${bookingId}/fingerprints`,
  EditProperties: (bookingId) =>
    `${MainRoutes.JmsManagement}/booking/${bookingId}/properties`,
  EditHousing: (bookingId) =>
    `${MainRoutes.JmsManagement}/booking/${bookingId}/housing`,
};
